// Spec 2026-10-25 A2: no credentials or personal data in Sentry. The SDK
// records request URLs on xhr/fetch breadcrumbs; the login calls put the
// customer's phone and the SMS code in the query (services/AuthService.js).
// Same keys and replacement as the kiosk's redactQuery.
const SECRET_KEYS = ['code', 'phone', 'email'];

const decodeKey = (key) => {
  try {
    return decodeURIComponent(key).toLowerCase();
  } catch {
    return key.toLowerCase();
  }
};

export function redactUrlQuery(url) {
  if (typeof url !== 'string') return url;
  const q = url.indexOf('?');
  if (q === -1) return url;
  const hash = url.indexOf('#', q);
  const query = url.slice(q + 1, hash === -1 ? undefined : hash);
  const fragment = hash === -1 ? '' : url.slice(hash);
  const redacted = query
    .split('&')
    .map((pair) => {
      const eq = pair.indexOf('=');
      if (eq === -1) return pair;
      const key = pair.slice(0, eq);
      return SECRET_KEYS.includes(decodeKey(key)) ? `${key}=[removed]` : pair;
    })
    .join('&');
  return `${url.slice(0, q + 1)}${redacted}${fragment}`;
}

export function scrubBreadcrumb(breadcrumb) {
  if (
    (breadcrumb?.category === 'xhr' || breadcrumb?.category === 'fetch') &&
    typeof breadcrumb.data?.url === 'string'
  ) {
    return { ...breadcrumb, data: { ...breadcrumb.data, url: redactUrlQuery(breadcrumb.data.url) } };
  }
  return breadcrumb;
}
